// extracted by mini-css-extract-plugin
export default {"currentCountdown":"Countdown_currentCountdown__+x7lz","icon":"Countdown_icon__RpgnP","expiresIn":"Countdown_expiresIn__ohrk7","countdown":"Countdown_countdown__bSMgJ"};